var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("path",{"d":"M5.67,22.63H.81V8.7H5.67Zm10.09-9.39a2.14,2.14,0,0,0-2.14,2.14v7.25H8.51V8.7h5.11v1.59a6.76,6.76,0,0,1,4.28-1.6c3.17,0,5.37,2.35,5.37,6.81v7.13H17.9V15.38A2.14,2.14,0,0,0,15.76,13.23Zm-10-9.36a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,5.74,3.88Z","fill":"current","stroke":"current","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"})));
}

Linkedin.defaultProps = {"version":"1.1","viewBox":"0 0 140 140"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
